import React, { useEffect, useState } from 'react';
import { getHighlight } from '../../../../apis/Ambition';
import { PieChart } from 'react-minimal-pie-chart';
import { getAirconCarbon, getIndustrialCarbon, getOtherVehicleCarbon, getSuppresantCarbon, getVehicleCarbon } from '../../../../apis/Report/Report';
import { useRef } from 'react';
import { fontReport } from '../../../../apis/util';
import { PRINT_WIDTH } from '..';

export const Scope1 = ({ img, keyHighlight, number }) => {
  const [text, setText] = useState();
  const [vehicleCarbon, setVehicleCarbon] = useState(0);
  const [otherVehicleCarbon, setOtherVehicleCarbon] = useState(0);
  const [airconCarbon, setAirconCarbon] = useState(0);
  const [industrialCarbon, setIndustrialCarbon] = useState(0);
  const [suppresantCarbon, setSuppresantCarbon] = useState(0);

  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({
      key: keyHighlight,
      setValue: setText
    });
  };
  const options = {
    chart: {
      events: {
        mounted: (chart) => {
          chart.windowResizeHandler();
        }
      }
    }, labels: ["Product Carbon", "Other Vehicle Carbon", "Aircon/refrigerant Carbon", "Industrial Gas Carbon", "Fire Suppresant Carbon"],
    legend: {
      fontSize: "20px",
      markers: {
        height: "20px",
        width: "20px"
      }
    }
  };
  const covidData = [vehicleCarbon, otherVehicleCarbon, airconCarbon, industrialCarbon, suppresantCarbon];

  useEffect(() => {
    getVehicleCarbon({ total: vehicleCarbon, setTotal: setVehicleCarbon });
    getOtherVehicleCarbon({ total: vehicleCarbon, setTotal: setOtherVehicleCarbon });
    getAirconCarbon({ total: vehicleCarbon, setTotal: setAirconCarbon });
    getIndustrialCarbon({ total: vehicleCarbon, setTotal: setIndustrialCarbon });
    getSuppresantCarbon({ total: vehicleCarbon, setTotal: setSuppresantCarbon });
  }, []);

  useEffect(() => {
  }, [vehicleCarbon]);
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="ourenvironmentalaim" ref={ref}>
      <div className="ourenvironmentalaim__title">
        <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.7/PRINT_WIDTH,"rem") }}><b>Scope</b> 1</h4>
        <img src={img} alt="" />
      </div>
      <div className="scopes__body">
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.3/PRINT_WIDTH,"rem") }}>
          {text}
        </h5>

      </div>
      <div>

      </div>
      <div className="mx-auto mt-4 chart_chart_chart" style={{ width: "100%" }}>

        <div className="" style={{ padding: "20%", width: "70%" }}>


          <PieChart
            data={[
              { title: 'Vehicle Carbon', value: vehicleCarbon, color: '#c2a2ac' },
              { title: 'Two', value: otherVehicleCarbon, color: '#ddd8db' },
              { title: 'Three', value: airconCarbon, color: '#afc4b9' },
              { title: 'Three', value: industrialCarbon, color: '#bbd4d2' },
              { title: 'Three', value: suppresantCarbon, color: '#e2f15f' },
            ]}
            // label={({ dataEntry }) => dataEntry.title}
            // labelStyle={(index) => ({
            //   // fill: dataMock[index].color,
            //   fontSize: '5px',
            //   fontFamily: 'sans-serif',
            // })}
            // labelPosition={0}
            lineWidth={10} paddingAngle={4} />
        </div>
        <div className="" style={{ width: "30%" }}>
          <div className="d-flex mb-2">
            <div className='me-1' style={{ height: "20px", width: "30px", backgroundColor: "#c2a2ac" }}></div>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.1/PRINT_WIDTH,"rem") }}>Vehicle Carbon: {vehicleCarbon}</h5>
          </div>
          <div className="d-flex mb-2"><div className='me-1' style={{ height: "20px", width: "30px", backgroundColor: "#ddd8db" }}></div>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.1/PRINT_WIDTH,"rem") }}>Other Vehicle Carbon: {otherVehicleCarbon}</h5>
          </div>
          <div className="d-flex mb-2"><div className='me-1' style={{ height: "20px", width: "30px", backgroundColor: "#afc4b9" }}></div>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.1/PRINT_WIDTH,"rem") }}>Aircon/refrigerant  Carbon: {airconCarbon}</h5>
          </div>
          <div className="d-flex mb-2"><div className='me-1' style={{ height: "20px", width: "30px", backgroundColor: "#bbd4d2" }}></div>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.1/PRINT_WIDTH,"rem") }}>Industrial Gas Carbon: {industrialCarbon}</h5>
          </div>
          <div className="d-flex mb-2"><div className='me-1' style={{ height: "20px", width: "30px", backgroundColor: "#e2f15f" }}></div>
            <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.1/PRINT_WIDTH,"rem") }}>Fire Suppresant Carbon: {suppresantCarbon}</h5>
          </div>
        </div>
      </div>

    </div>
  );
};
